import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-best-practices-home',
  templateUrl: './best-practices-home.component.html',
  styleUrls: ['./best-practices-home.component.scss']
})
export class BestPracticesHomeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
